import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-cards',
  imports: [CommonModule],
  templateUrl: './cards.component.html',
  styleUrl: './cards.component.scss'
})
export class CardsComponent {
  @Input() imageSource!: string;
  @Input() isShow!: boolean;
  @Input() cardTitle!: string;
  @Input() cardDescription!: string;
  @Output() onCardClick = new EventEmitter<any>();


  onCardHandler(){
    this.onCardClick.emit();
  }
}
